import React from "react";

import { GetHeroContent } from "../HeroSection/HeroBottom";
import HeadingComponent from "@/components/Molecules/Heading/V1";
import AttributesComponent from "./Attributes";
import IngredientsComponent from "./IngredientsComponent";

import {
  Wrapper,
  Container,
  StyledLHSBox,
  RHSBox,
  MethodList,
  MethodBox,
  MobileDiv,
} from "./style";

const DynamicContent = ({
  data = {},
  heroContentData,
  attributeData,
  ingredientsData,
  methodData,
  width,
}) => {
  return (
    <Wrapper>
      <Container>
        {width <= 992 && (
          <MobileDiv>
            <GetHeroContent data={heroContentData} />
          </MobileDiv>
        )}
        <StyledLHSBox>
          {attributeData?.attributes?.length > 0 && (
            <AttributesComponent data={attributeData} />
          )}
          {ingredientsData?.ingredient?.length > 0 && (
            <IngredientsComponent data={ingredientsData} />
          )}
        </StyledLHSBox>
        {methodData?.methodList?.length > 0 && (
          <RHSBox>
            <HeadingComponent title={methodData?.heading} m="0 0 16px 0" />
            <MethodBox>
              {methodData?.methodList?.map((method, index) => (
                <MethodList
                  variant="paragraph1"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: method }}
                />
              ))}
            </MethodBox>
          </RHSBox>
        )}
      </Container>
    </Wrapper>
  );
};

export default DynamicContent;
